import React from 'react'
import { Icon } from './Icon'

export const Location = ({ location, iconProps }) =>
  <span>
    <Icon className="fas fa-map-marker-alt" {...iconProps} />
    {location}
  </span>